module.exports = __webpack_public_path__ + "img/generacion_con_ia.39a824ec.png";